import React, { useEffect, useState } from 'react';
import SideBarElements from './sideBarOption';
import { sidebarDetails } from '../../utils/const';
import { connect } from 'react-redux';
import { htmlDecode } from '../../utils/commonFunctions';
import { withRouter } from 'react-router';
import { setActiveKey } from '../../redux/myCourse/myCourse.actions';
import { compose } from 'redux';
import MenuAnimation from '../utils/animations/menu';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import { getAllCourses } from '../../redux/changeCourse/changeCourse.actions';

const SidebarContents = React.memo(function SidebarContents({
	isParent,
	allCourseDetails,
	changeActiveCourse,
	getAllCourses }) {

	const pathName = (window.location.pathname.split("/").length > 1) ? window.location.pathname.split("/")[1] : null;

	const [selfRender, setSelfRender] = useState(false)
	const freeCourses = []

	useEffect(() => {
		getAllCourses();
	}, [getAllCourses]);

	// useEffect(() => {
	// 	if (allCourseDetails.length > 0) {
	// 		sidebarDetails['MyCourses'].childs = []
	// 		allCourseDetails.map((item) => {
	// 			if (item.is_active === true || item.is_active === 1) {
	// 				sidebarDetails['MyCourses'].childs.push(item)
	// 			}
	// 		})
	// 	}
	// }, [allCourseDetails]);

	if (allCourseDetails.length > 0) {
		sidebarDetails['MyCourses'].childs = []
		allCourseDetails.map((item) => {
			if ((item.is_active === true || item.is_active === 1) && item.course_name !== 'free') {
				sidebarDetails['MyCourses'].childs.push(item)
			} else if (item.course_name === 'free') {
				freeCourses.push(item)
			}
		})
	}

	return (
		<MenuAnimation open={true} className="step-main-nav" id="main-menu">
			{/* {Object.keys(units).length > 0 &&
				window.location.pathname === '/mycourse' ? (
				<>
					<SideBarElements redirectLink={'/mycourse'} PageName="My Course" />
					{Object.keys(units).map((unit) => {
						const { unit_name } = units[unit];
						return (
							<li
								key={`key_${course_id}_${unit}`}
								className={`menu-unit ${parseInt(unit, 10) === activeUnit ? 'active-menu-unit' : ''
									}`}
								onClick={() => {
									setActiveKey(parseInt(unit, 10));
									document.getElementById(`unit_${course_id}_${unit}`).scrollIntoView({
										behavior: 'smooth',
										block: 'center',
										inline: 'nearest',
									});
								}}
							>
								{htmlDecode(unit_name)}
							</li>
						);
					})}
				</>
			) : null} */}
			{Object.keys(sidebarDetails)
				.filter(
					(x) =>
						(window.outerWidth < 768 ? x : sidebarDetails[x]?.isMobile !== 1) && //show profile & history in mob view
						(!!isParent ? x : sidebarDetails[x]?.isParent !== 1), //show kids course if isParent equals 1
				)
				.map((detail, index) => {
					return (
						<>

							{detail !== 'MyCourses' && (
								detail === 'MyDashboard' ?
									freeCourses.length > 0 ?
										<SideBarElements key={`${index}_${detail}`} {...sidebarDetails[detail]} index={index} />
										: null
									: <SideBarElements key={`${index}_${detail}`} {...sidebarDetails[detail]} index={index} />
							)}

							{sidebarDetails[detail].childs?.length > 0 && detail === 'MyCourses' && (
								<>
									<SideBarElements key={`${index}_${detail}`} {...sidebarDetails[detail]} index={index} />
									{
										sidebarDetails[detail].childs?.map((item, index) => {
											return (
												<li
													onClick={() => { changeActiveCourse(item.course_id); localStorage.setItem('active_course_id', item.course_id); setSelfRender(!selfRender) }}
													key={`${item.course_id}-${index}`}
													className={`menu-unit ${(localStorage.getItem('active_course_id') == item.course_id && pathName === 'mycourse' && item.course_name !== 'free') ? 'menu-unit-active' : ''}`}
												>
													{htmlDecode(item.course_title)}
												</li>
											)
										})
									}
								</>
							)}
						</>
					)
				})
			}
		</MenuAnimation>
	);
})

const mapStateToProps = (state) => {
	const {
		requestedUnit,
		currentUnitOrder,
	} = state.rootReducer.myCourse;

	const allCourseDetails = state.rootReducer.changeCourse.courseDetails;
	const { isParent: parent } = state.rootReducer.profileDetails;
	const { user_profile: { isParent } = {} } = state.rootReducer.userDetails;

	return {
		requestedUnit,
		currentUnitOrder,
		isParent: isParent || parent,
		allCourseDetails: allCourseDetails || null
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
		getAllCourses: () => dispatch(getAllCourses())
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(SidebarContents);
